import { RootScopeEvents } from '../root-scope-types';
import { EndCallReasons } from '../doxy-analytics/tracks/video-session-end';
import * as dokbot from '../../../modules/dokbot';
const SKIP_SURVEY_REASONS = [
    EndCallReasons.PAUSED,
    EndCallReasons.RESTARTED,
    EndCallReasons.RESTART_FROM_SETTINGS,
    EndCallReasons.RESTART_FROM_PARTICIPANT_ERROR,
    EndCallReasons.RESTART_FOR_GROUP,
    EndCallReasons.RESTART_FOR_AUDIO_TYPE,
];
export class PatientSurveyLauncher {
    constructor($rootScope, DokbotPatientSurveyService, $ngRedux) {
        this.$rootScope = $rootScope;
        this.DokbotPatientSurveyService = DokbotPatientSurveyService;
        this.$ngRedux = $ngRedux;
    }
    init() {
        let isHold = false;
        this.$rootScope.$on(RootScopeEvents.ACTIVE_PROVIDER.JOIN_SESSION_SUCCESS, () => (isHold = false));
        this.$rootScope.$on(RootScopeEvents.ACTIVE_PROVIDER.END_REASON, (_e, reason) => {
            if (SKIP_SURVEY_REASONS.includes(reason)) {
                isHold = true;
            }
            else {
                isHold = false;
            }
        });
        this.$rootScope.$on(RootScopeEvents.ACTIVE_PROVIDER.JOIN_SESSION_SUCCESS, () => (isHold = false));
        const unlisten = this.$rootScope.$on(RootScopeEvents.ACTIVE_PROVIDER.SESSION_DISCONNECTED, () => {
            if (!isHold) {
                unlisten();
                const { patientSurveyId, isDokbotExtensionInstalled, patientSurveyFrequency, } = dokbot.selectors.getWorkflow(this.$ngRedux.getState());
                if (isDokbotExtensionInstalled && patientSurveyId) {
                    dokbot.initialiser.launchDelayedOneIn(patientSurveyFrequency || 10);
                    return;
                }
                this.DokbotPatientSurveyService.launchDelayedOneIn({
                    oneInNumber: 10,
                });
            }
        });
    }
}
